import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AdminAuthProvider } from "./AdminAuthContext";
import AdminLayout from "./AdminLayout";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminProgramListPage from "./pages/AdminProgramListPage";
import AdminProgramEditPage from "./pages/AdminProgramEditPage";
import AdminArticleListPage from "./pages/AdminArticleListPage";
import AdminArticleEditPage from "./pages/AdminArticleEditPage";
import AdminLeadsPage from "./pages/AdminLeadsPage";

// Mounted at /admin/* by AppRoutes.js, with its own auth (no Firebase, JWT
// bearer token per PATTERNS.md "eventshouse-auth") completely separate from
// the public site's Redux store — see src/admin/README.md for the full
// picture of this area.
export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="login" element={<AdminLoginPage />} />
        <Route element={<AdminLayout />}>
          <Route index element={<Navigate to="programs" replace />} />
          <Route path="programs" element={<AdminProgramListPage />} />
          <Route path="programs/:id" element={<AdminProgramEditPage />} />
          <Route path="articles" element={<AdminArticleListPage />} />
          <Route path="articles/:id" element={<AdminArticleEditPage />} />
          <Route path="leads" element={<AdminLeadsPage />} />
        </Route>
      </Routes>
    </AdminAuthProvider>
  );
}
